module.exports = __webpack_public_path__ + "static/media/zw.6ac3949a.svg";